import { Row, Col, Card, CardHeader, CardBody } from "reactstrap";
import PropTypes from "prop-types";
import React from "react";

import { Modal, CustomerForm } from "..";

const CreateActionModal = (props) => {
  const { id, title, itemId, reload, customer } = props;

  let form = null;
  if (customer)
    form = itemId ? (
      <CustomerForm id={itemId} reload={reload} />
    ) : (
      <CustomerForm reload={reload} />
    );

  return (
    <Modal id={id}>
      <div className="modal-content">
        <Row>
          <Col xs="12">
            <Card>
              <CardHeader>
                <strong>{title}</strong>
                <button
                  type="button"
                  data-dismiss="modal"
                  className="close align-self-baseline"
                  aria-label="Close"
                >
                  <span>&times;</span>
                </button>
              </CardHeader>
              <CardBody>{form}</CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

CreateActionModal.defaultProps = {
  itemId: null,
  user: false,
  property: false,
  promotion: false,
  client: false,
};

CreateActionModal.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  reload: PropTypes.func.isRequired,
  itemId: PropTypes.string,
  user: PropTypes.bool,
  property: PropTypes.bool,
  promotion: PropTypes.bool,
  client: PropTypes.bool,
};

export default CreateActionModal;



// WEBPACK FOOTER //
// ./client/react/Admin/components/CreateActionModal/index.jsx